export function renameItemInSidebar(type, key, newKey) {
  type = this.getPlural(type)

  const item = this.call('findFileSidebarItem', type, key)
  if (!item) {
    return
  }

  item.state.update({
    key: newKey
  })
}

export async function rename(type, oldKey, newKey) {
  if (!type || !oldKey || !newKey) {
    return this.error(
      'Type, old name or new name is not defined for rename operation'
    )
  }

  type = this.getPlural(type)

  const confirmMsg = `Do you want to rename "${oldKey}" to "${newKey}" in ${type}?`
  if (!window.confirm(confirmMsg)) {
    return false
  }

  let item = this.call('getItem', oldKey, type)

  if (!item) {
    this.call('openNotification', {
      type: 'error',
      title: 'Could not find target element',
      message: `We could not find ${oldKey} in ${type}`
    })
    return this.error('Could not find target element')
  }

  if (this.call('getItem', newKey, type)) {
    this.call('openNotification', {
      type: 'error',
      title: 'Could not rename',
      message: `We could not rename to ${newKey} as it already exists`
    })
    return this.error('Could not rename')
  }

  item = this.call('deepClone', item)
  item.key = newKey

  this.call('removeAny', type, oldKey, {
    skipConfirmation: true,
    skipSidebar: true
  }) // add skipSidebar, skipConfirmation
  this.call('createItem', type, newKey, item, {
    skipSidebar: true
  })

  this.call('renameItemInSidebar', type, key, newKey)
}
